import { ExternalLink, BookMarked } from "lucide-react";
import { Reveal, SectionHeading } from "./common";
import { FONTI } from "../data/content";

export const Fonti = () => (
  <section id="fonti" className="relative grain bg-ivory py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-3xl">
        <SectionHeading
          eyebrow="Per studiare meglio"
          title="Fonti e approfondimenti"
          testid="section-fonti-title"
        />
        <Reveal delay={0.15}>
          <p className="mt-8 text-base sm:text-lg text-taupe leading-relaxed">
            Questo progetto si basa su fonti istituzionali e divulgative
            affidabili. Quando una data o una ricostruzione è oggetto di
            dibattito tra gli studiosi, il sito la presenta con formule di
            cautela — <em>secondo la tradizione</em>,{" "}
            <em>secondo la documentazione disponibile</em> — distinguendo
            sempre tra fatti documentati, tradizioni e leggende.
          </p>
        </Reveal>
      </div>

      <div className="mt-12 grid sm:grid-cols-2 gap-4">
        {FONTI.map((fonte, i) => (
          <Reveal key={fonte.name} delay={(i % 2) * 0.07}>
            <a
              href={fonte.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`fonte-link-${i}`}
              className="group flex items-start justify-between gap-4 h-full bg-sand border border-stone hover:border-gold p-6 sm:p-7 transition-all duration-500 hover:shadow-[0_12px_35px_rgba(43,35,31,0.08)]"
            >
              <div className="flex items-start gap-4">
                <BookMarked size={20} strokeWidth={1.6} className="text-gold mt-1 flex-shrink-0" />
                <div>
                  <h3 className="font-serif text-lg sm:text-xl font-semibold text-espresso group-hover:text-terracotta transition-colors duration-300">
                    {fonte.name}
                  </h3>
                  <p className="mt-1.5 text-sm text-taupe leading-relaxed">{fonte.desc}</p>
                </div>
              </div>
              <ExternalLink
                size={16}
                className="text-fog group-hover:text-gold flex-shrink-0 mt-1.5 transition-colors duration-300"
              />
            </a>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 border-l-2 border-gold bg-sand/60 p-6 sm:p-8 max-w-3xl">
          <h3 className="font-mono text-xs tracking-[0.25em] uppercase text-gold">
            Nota metodologica
          </h3>
          <p className="mt-3 text-sm sm:text-base text-taupe leading-relaxed">
            Le date di fondazione (1369–1391) sono riportate{" "}
            <strong className="text-espresso">secondo la tradizione storiografica</strong>:
            la documentazione superstite non permette di stabilirle con
            certezza assoluta. Il racconto del dito di Santa Caterina è una{" "}
            <strong className="text-espresso">leggenda devozionale</strong>, citata come
            tale. Gli affreschi non sono attribuiti ad artisti identificati: le
            fonti parlano di più botteghe attive nel Quattrocento.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
